import { Link } from 'react-router-dom';
import { topRated } from '@/mocks/movies';

export default function HotRanking() {
  return (
    <section className="py-8 md:py-10 bg-background-100/50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-5">
          <div className="flex items-center gap-3">
            <div className="w-1 h-5 rounded-full bg-accent-500" />
            <h2 className="text-lg md:text-xl font-heading text-foreground-950">热门排行</h2>
            <span className="px-2 py-0.5 rounded-full bg-accent-500/15 text-accent-500 text-xs font-medium whitespace-nowrap">
              TOP 10
            </span>
          </div>
          <Link
            to="/category/all"
            className="text-sm text-foreground-500 hover:text-accent-500 transition-colors whitespace-nowrap cursor-pointer flex items-center gap-1"
          >
            查看全部
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-xs"></i>
            </span>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 md:gap-5">
          {topRated.map((movie, index) => (
            <Link
              key={movie.id}
              to={`/category/${movie.categorySlug}`}
              className="group flex items-center gap-3 p-3 rounded-lg bg-background-50 hover:bg-background-200/50 transition-colors cursor-pointer border border-background-200/40"
            >
              <div className="relative flex-shrink-0">
                <span className={`w-8 h-8 rounded-full flex items-center justify-center font-heading text-sm font-bold ${
                  index < 3
                    ? 'bg-accent-500 text-background-50'
                    : 'bg-background-200 text-foreground-500'
                }`}>
                  {index + 1}
                </span>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-medium text-foreground-800 truncate group-hover:text-accent-500 transition-colors">
                  {movie.title}
                </h3>
                <div className="flex items-center gap-2 mt-0.5">
                  <span className="text-xs text-primary-500 font-semibold">{movie.rating}</span>
                  <span className="text-xs text-foreground-400">{movie.year}</span>
                  <span className="text-xs text-foreground-400 truncate">{movie.category}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}